/**
 * Created by Pankaj singh on 2019-10-15.
 */
import {BaseView} from "@nolimitcity/slot-game/bin/core/base/BaseView";
import {ResourcesGroupName} from "@nolimitcity/slot-game/bin/core/resource/ResourcesGroupName";
import {IMultiplierPosition, ISymbolPositions} from "./GenieFeatureController";
import {StateReelSymbol} from "@nolimitcity/slot-game/bin/core/reelsymbol/StateReelSymbol";
import {TimelineLite, TweenLite} from "gsap";
import {StageManager} from "@nolimitcity/slot-game/bin/core/stage/StageManager";
import {RomanEmpireGameConfig} from "../../RomanEmpireGameConfig";
import {GameResources} from "@nolimitcity/slot-game/bin/core/resource/GameResources";
import {Helper} from "@nolimitcity/slot-game/bin/core/utils/Helper";
import {Reels} from "@nolimitcity/slot-game/bin/core/reel/reelarea/Reels";
import {Multiplier} from "./Multiplier";
import {GameConfig} from "@nolimitcity/slot-game/bin/core/gameconfig/GameConfig";
import {SpineTween} from "@nolimitcity/slot-game/bin/core/animation/SpineTween";
import {TimelineSprite} from "@nolimitcity/slot-game/bin/core/animation/TimelineSprite";
import {Logger} from "@nolimitcity/slot-launcher/bin/utils/Logger";
import Timeline = gsap.Timeline;
import {RomanEmpireGameModuleConfig} from "../../RomanEmpireGameModuleConfig";
import {SoundManager} from "../../resource/sound/SoundManager";
import {RomanEmpireSoundConfig} from "../../RomanEmpireSoundConfig";

export interface IWilSym extends ISymbolPositions {
    sprite: TimelineSprite
}

export class GenieFeatureView extends BaseView {

    private readonly SCATTER_NAME: string = "S";
    private _layer: PIXI.Container;
    private _staticFeatureContainer: PIXI.Container;
    private _dynamicFeatureContainer: PIXI.Container;
    private _symbolMultiplierArr: Multiplier[] = [];
    private _wildSymArr: IWilSym[] = [];

    //private _beforeSymLayer: PIXI.Container;

    constructor(resourcesGroup?: ResourcesGroupName) {
        super(resourcesGroup);
        this._layer = StageManager.getLayer(RomanEmpireGameConfig.instance.LAYERS.GINIE_FEATURE.name);
        //this._beforeSymLayer = StageManager.getLayer(RomanEmpireGameConfig.instance.LAYERS.BEFORE_SYMBOL.name);

    }

    protected initAnimations(): void {
        this._layer.addChild(this);
        this._staticFeatureContainer = new PIXI.Container();
        this._dynamicFeatureContainer = new PIXI.Container();
        this.addChild(this._staticFeatureContainer, this._dynamicFeatureContainer);
        // const bitmap = new PIXI.BitmapText("33.333512.50.51.20", {
        //     font: {
        //         name: "NumbersWinCountUp",
        //         size:32
        //     },
        //     align:"center"
        // });
        // this.addChild(bitmap);
        // bitmap.position.set(0,300);
    }

    public startPresentation(triggeredSymArr: ISymbolPositions[], featureType: string, isReSpin: boolean, multiplierOverlay: IMultiplierPosition[]): TimelineLite {
        return this.getTriggeredAnim(triggeredSymArr, featureType, isReSpin, multiplierOverlay);
    }

    /**
     * To get Triggered symbol animation on feature
     * @param triggeredSymArr
     * @param featureType
     */
    private getTriggeredAnim(triggeredSymArr: ISymbolPositions[], featureType: string, isReSpin: boolean, multiplierOverlay: IMultiplierPosition[]): TimelineLite {
        const timeline: TimelineLite = new TimelineLite();
        //timeline.add(this.getLockAnim(triggeredSymArr[0]));
        timeline.add(this.getFeatureTriggeredSprite(triggeredSymArr, featureType, isReSpin, multiplierOverlay));
        return timeline;
    }

    public dimMultiplier(winStates: boolean[][]) {
        this._symbolMultiplierArr.forEach((multiplier) => {
            if (!winStates[multiplier.reelId][multiplier.symbolId]) {
                multiplier.text.tint = 0x555555;
                multiplier.bg.visible = false;
            }
        });
        this.dimWildsOverlay(winStates);
    }

    public dimWildsOverlay(winStates: boolean[][]) {
        this._wildSymArr.forEach((wildSym) => {
            if (!winStates[wildSym.reelId][wildSym.symbolId]) {
                wildSym.sprite.tint = 0x555555;
            }
        });
    }

    /**
     * make spiral multiplier as per below rules
     * 2 different, do 3 & 3
     * 3 different, do 2, 2, 2
     * 4, different, do 2,2,1,1 (1,1 on the highest mul)
     * 5 different, 2,1,1,1,1 (2 on the lowest mult)
     * 6, all different
     * */
    private getSpiralMultiplierVal(multiplierSet: Set<number>): number[] {
        let valArr = Array.from(multiplierSet);//[...multiplierSet];
        switch (multiplierSet.size) {
            case 1 :
                valArr = [...valArr, ...valArr, ...valArr, ...valArr, ...valArr, ...valArr];
                break;
            case 2 :
                valArr = [...valArr, ...valArr, ...valArr];
                break;
            case 3 :
                valArr = [...valArr, ...valArr];
                break;
            case 4 :
                let max1: number = Math.max(...valArr);
                valArr.splice(valArr.indexOf(max1), 1);
                let max2: number = Math.max(...valArr);
                valArr.splice(valArr.indexOf(max2), 1);
                valArr = [max1, max2, ...valArr, ...valArr];
                break;
            case 5 :
                valArr = [...valArr];
                let min: number = Math.min(...valArr);
                valArr.splice(valArr.indexOf(min), 1);
                valArr = [min, min, ...valArr];
                break;
            default :
                valArr.splice(6);
        }
        Logger.logDev("multiplier set : ", multiplierSet);
        Logger.logDev("multiplier for spiral : ", valArr);
        return valArr;
    }

    /**
     *  create random multiplier and there spiral points to animate.
     *  @param pos : position
     *  @param isTriggeredInLastReel : true if m2m3 on last reel
     * */
    private getRandomMultiplierContainer(pos: number[], multiplierOverlay: IMultiplierPosition[]): PIXI.Container {
        const multiplierContainer = new PIXI.Container();
        this._dynamicFeatureContainer.addChild(multiplierContainer);
        const multiplierSet = new Set(multiplierOverlay.map((obj) => {
            return obj.value;
        }));
        let valArr: number[] = this.getSpiralMultiplierVal(multiplierSet);
        const len: number = valArr.length;
        const finalPosArr = [{"x": -46, "y": 104}, {"x": -127, "y": 13}, {"x": -57, "y": -92}, {
            "x": 69,
            "y": -95
        }, {"x": 139, "y": 1}, {"x": 89, "y": 101}];
        for (let i = 0; i < len; i++) {
            const randomNum: number = this.getRandomNumFromArr(valArr);
            const multiplier = new Multiplier(valArr[randomNum], false, pos[0], pos[1]);
            const animSyncPoints = this.getAnimSyncPoints();
            multiplier.spiralPoints = animSyncPoints.concat(finalPosArr.slice(0, len - i));

            valArr.splice(randomNum, 1);
            multiplierContainer.addChild(multiplier);
        }
        multiplierContainer.position.set(pos[0], pos[1]);
        //multiplierContainer.scale.set(0);
        return multiplierContainer;
    }

    private getRandomNumFromArr(arr: number[]): number {
        return Math.floor(Math.random() * arr.length);
    }

    /**
     *  To get random multiplier animation
     *  @param pos : position
     *  @param isTriggeredInLastReel : true if m2m3 on last reel
     * */
    private getRandomMultiplierAnim(pos: number[], isTriggeredInLastReel: boolean, multiplierOverlay: IMultiplierPosition[]): TimelineLite {
        const tl: TimelineLite = new TimelineLite();
        const multiplierContainer = this.getRandomMultiplierContainer(pos, multiplierOverlay);
        this._dynamicFeatureContainer.addChild(multiplierContainer);
        multiplierContainer.scale.set(isTriggeredInLastReel ? 0.8 : 1);

        multiplierContainer?.children.forEach((multiplier: PIXI.DisplayObject, index) => {
            multiplier = multiplier as Multiplier;
            multiplier.alpha = 0;
            tl.add([
                TweenLite.to(multiplier, 0.001, {alpha: 1}),
                TweenLite.fromTo(multiplier.scale, 1.6, {x: 0.3, y: 0.3}, {x: 1, y: 1}),
                TweenLite.to(multiplier, 2, {
                    bezier: (multiplier as Multiplier).spiralPoints
                })], index * 0.05);
        });

        tl.add(TweenLite.to(multiplierContainer.scale, 1.5, {x: 0.8, y: 0.8}), 0);
        tl.add(TweenLite.to(multiplierContainer.scale, 0.3, {x: 0, y: 0}), 3.3);
        //tl.add(TweenLite.to({}, 11111111111111111111, {}));
        return tl;
    }


    private roundTo(input: number, sigDigs: number): number {
        return Math.round(input * Math.pow(10, sigDigs)) / Math.pow(10, sigDigs);
    }


    private getAnimSyncPoints(): any[] {
        return [{"x": 16, "y": -10}, {"x": -25, "y": 15.21875}, {"x": -65, "y": 45.21875}, {
            "x": -101,
            "y": 60.21875
        }, {"x": -133, "y": 51.21875}, {"x": -151, "y": 31.21875}, {"x": -157, "y": -1.78125}, {
            "x": -141,
            "y": -30.78125
        }, {"x": -115, "y": -56.78125}, {"x": -80, "y": -81.78125}, {"x": -33, "y": -99.78125}, {
            "x": 5,
            "y": -103.78125
        }, {"x": 46, "y": -102.78125}, {"x": 75, "y": -91.78125}, {"x": 122, "y": -55.78125}, {
            "x": 145,
            "y": -20.78125
        }, {"x": 154, "y": 8.21875}, {"x": 146, "y": 43.21875}, {"x": 114, "y": 68.21875}, {
            "x": 63,
            "y": 94.21875
        }, {"x": 19, "y": 103.21875}, {"x": -24, "y": 98.21875},
        ];
    }

    /**
     *  To create spiral points. math formula return the array of points in a spiral
     *  @param origin : origin points
     *  @param revolutions : spiral layer counts
     *  @param pointCount : total points in spiral
     *  @param clockwise : direction clockwise or anticlockwise
     *  @param padding : gap between two spiral layer
     *  @param finalAngle : acceleration stop points if many objects created
     * */
    private makeSpiralPoints(origin: any, revolutions: number, pointCount: number, clockwise: boolean, padding: number, finalAngle: number): any[] {
        const direction = clockwise ? 1 : -1;
        const circle = padding / (2 * Math.PI);
        const step = (2 * Math.PI * revolutions) / pointCount;
        const points: any [] = [];
        let angle: number, x: number, y: number;
        for (let i = 0; i <= pointCount; i++) {
            angle = direction * step * i + finalAngle;
            x = this.roundTo((circle * angle) * Math.cos(angle) + origin.x, 2);
            y = this.roundTo((circle * angle) * Math.sin(angle) + origin.y, 2);
            points.push({"x": x, "y": y});
        }
        return points;
    }

    /**
     * reel id will be of M2 symbol will always be first sym in triggered pos
     * isTriggeredInLastReel : true if M2 pos will be in outer reel or Symbol to fix spiral area of multiplier animation
     * @param reelId
     * @param symbolId
     */
    private isTriggeredInLastReel(reelId: number, symbolId: number): boolean {
        return (reelId == 0 || reelId == 3) || (symbolId == 0 || symbolId == 2)
    }

    private createSingleSprite(texture: string, pos?: number[]) {
        const sprite = new PIXI.Sprite(GameResources.getTextures(texture)[0]);
        sprite.anchor.set(0.5);
        pos && sprite.position.set(pos[0], pos[1]);
        sprite.alpha = 0;
        return sprite;
    }

    /**
     *  To get Triggered feature animation
     *  @param triggeredSymArr : position of Triggered symbols m2 and m3
     *  @param featureType : type of feature like genie multiplier, genie coinWin
     *  @param isReSpin : true if Genie reSpin triggered
     *  @param multiplierOverlay : array of multiplier for a Genie wishes feature
     * */
    private getFeatureTriggeredSprite(triggeredSymArr: ISymbolPositions[], featureType: string, isReSpin: boolean, multiplierOverlay: IMultiplierPosition[]): TimelineLite {
        const tl: TimelineLite = new TimelineLite();
        let pos: number[] = Helper.getSymbolPositions(triggeredSymArr[0].reelId, triggeredSymArr[0].symbolId);
        pos[0] += RomanEmpireGameConfig.instance.SYMBOL_WIDTH * 0.5;
        const featureBgRays = this.createSprite("featureBgRays", undefined, undefined, undefined, true);
        const triggeredGlow = this.createSingleSprite("goldenPatch", pos);
        const m2 = this.createSingleSprite("M2/M2", pos);
        const m3 = this.createSingleSprite("M3/M3", pos);
        m2.anchor.set(1, 0.5);
        m3.anchor.set(0, 0.5);

        triggeredGlow.blendMode = PIXI.BLEND_MODES.ADD;
        const featureMagicSmokeStart = this.createSprite("featureMagicSmokeStart");
        const featureMagicSmokeLoop = this.createSprite("featureMagicSmokeLoop");
        const featureMagicSmokeEnd = this.createSprite("featureMagicSmokeEnd");

        this._dynamicFeatureContainer.addChild(m2, m3, triggeredGlow, featureMagicSmokeStart, featureMagicSmokeLoop, featureMagicSmokeEnd);

        featureBgRays.blendMode = PIXI.BLEND_MODES.ADD;
        featureBgRays.alpha = 0;
        featureMagicSmokeStart.hide();
        featureMagicSmokeLoop.hide();
        featureMagicSmokeEnd.hide();

        featureBgRays.position.set(pos[0], pos[1]);

        featureMagicSmokeStart.position.set(pos[0] + 5, pos[1]);
        featureMagicSmokeLoop.position.set(pos[0], pos[1]);
        featureMagicSmokeEnd.position.set(pos[0], pos[1]);

        //tl.add(featureM2M3.getAnimationAutoShowHide(true, false), 0);
        tl.add([
            RomanEmpireGameModuleConfig.foregroundAnimation.getSymbolAnimShow(triggeredSymArr[0].reelId, triggeredSymArr[0].symbolId),
            RomanEmpireGameModuleConfig.foregroundAnimation.getSymbolAnimShow(triggeredSymArr[1].reelId, triggeredSymArr[1].symbolId, undefined, true),
            () => SoundManager.playSound(RomanEmpireSoundConfig.instance.RFB_MULTI_CLOUD)
        ], 0);
        tl.add([
            TweenLite.to(triggeredGlow, 0.15, {alpha: 1}),
            TweenLite.to(featureBgRays, 0.15, {alpha: 1}),
            TweenLite.to(m2, 0.19, {alpha: 1}),
            TweenLite.to(m3, 0.19, {alpha: 1}),
            //TweenLite.to(m2m3Trigger, 0.19, {alpha: 1}),
            () => featureBgRays.playLoop(),
        ], 0.2);

        tl.add(featureMagicSmokeStart.getAnimationAutoShowHide(true, true), 0.5);
        tl.add(() => {
            featureMagicSmokeLoop.show();
            featureMagicSmokeLoop.playLoop();
            TweenLite.to(m2, 0.2, {alpha: 0});
            TweenLite.to(m3, 0.2, {alpha: 0});
        }, 1);
        tl.add(() => {
            TweenLite.to(triggeredGlow, 0.15, {alpha: 0});
        }, 0.38);
        // tl.add(() => {
        //     TweenLite.to(featureBgRays, 0.2, {alpha: 1});
        //     featureBgRays.playLoop();
        // }, 0.1);
        tl.add(() => {
            //featureBgLoop.show();
            //featureBgLoop.playLoop();
        }, 1);

        tl.add(this.getRandomMultiplierAnim(pos, this.isTriggeredInLastReel(triggeredSymArr[0].reelId, triggeredSymArr[0].symbolId), multiplierOverlay), 0.55);
        if (isReSpin) {
            tl.add([
                this.getRevealScatterSprite(triggeredSymArr),
                this.getRevealSymbolsTimeline(triggeredSymArr, this.SCATTER_NAME),
                TweenLite.to(featureBgRays, 0.5, {alpha: 0}),
            ]);
        } else {
            tl.add([
                () => {
                    TweenLite.to(featureMagicSmokeLoop, 0.001, {alpha: 0});
                    TweenLite.to(featureBgRays, 0.5, {alpha: 0});
                },
                featureMagicSmokeEnd.getAnimationAutoShowHide(true, true),
            ]);

            const multiplierAnim = this.getSymbolMultiplierAnim(multiplierOverlay, pos);
            const smokeBlast = this.getBlastAnim(pos);
            tl.add([
                smokeBlast,
                multiplierAnim,
                () => SoundManager.playSound(RomanEmpireSoundConfig.instance.RFB_MULTI_CLOUD_EXPLODE)
            ], "-=0.5");
        }
        tl.add(() => {
            featureBgRays.stopLoop();
            featureBgRays.hide();
            featureMagicSmokeLoop.stopLoop();
            featureMagicSmokeLoop.hide();
        });

        return tl;
    }


    /**
     * To get blast animation
     * @param pos : position
     */
    public getBlastAnim(pos: number[], tintColor?: number): TimelineLite {
        const tl: TimelineLite = new TimelineLite();
        const genieFeatureRays: TimelineSprite = this.createSprite("genieFeatureRays", pos, 70, undefined, true);
        genieFeatureRays.hide();
        genieFeatureRays.scale.set(0);
        const mask: PIXI.Graphics = new PIXI.Graphics();
        mask.clear();
        mask.beginFill();
        mask.drawRect(RomanEmpireGameConfig.instance.REEL_AREA_POS_X, RomanEmpireGameConfig.instance.REEL_AREA_POS_Y, RomanEmpireGameConfig.instance.REEL_AREA_WIDTH, RomanEmpireGameConfig.instance.REEL_AREA_HEIGHT);
        mask.endFill();
        const spine: PIXI.spine.Spine = new PIXI.spine.Spine(GameResources.getSpineAsset("smokeBlast"));
        const spineCopy: PIXI.spine.Spine = new PIXI.spine.Spine(GameResources.getSpineAsset("smokeBlast"));

        spine.position.set(pos[0], pos[1]);
        spineCopy.position.set(pos[0], pos[1]);
        spine.alpha = 0;
        spineCopy.alpha = 0;
        spine.mask = mask;
        spineCopy.mask = mask;
        spine.tint = tintColor || 0xFD40FF;
        spineCopy.tint = tintColor || 0xFD40FF;
        this._dynamicFeatureContainer.addChild(spine, spineCopy, mask);
        tl.add(() => {
            spine.alpha = 1;
            spineCopy.alpha = 1;
        });
        tl.add([
            new SpineTween(spine, 0, "smoke_blast_animation"),
            new SpineTween(spineCopy, 0, "smoke_blast_animation"),
            genieFeatureRays.getAnimationAutoShowHide(true, false, undefined, undefined, () => {
                TweenLite.to(genieFeatureRays, 0.3, {alpha: 0});
            }),
            TweenLite.to(genieFeatureRays.scale, 0.2, {x: 2, y: 2}),
            TweenLite.to(spine.scale, 0.7, {x: 1.2, y: 1.2}),
            TweenLite.to(spineCopy.scale, 0.2, {x: 1.3, y: 1.3})
        ]);
        return tl;
    }

    /**
     * To get Final multiplier animation for symbol
     * @param pos : position
     * @param multiplierOverlay : position of multiplier on symbol
     */
    private getSymbolMultiplierAnim(multiplierOverlay: IMultiplierPosition[], pos: number[]): TimelineLite {
        const tl: TimelineLite = new TimelineLite();
        this._symbolMultiplierArr.length = 0;
        multiplierOverlay.forEach((multiplierPos: IMultiplierPosition, index: number) => {
            const multiplier = new Multiplier(multiplierPos.value, true, multiplierPos.reelId, multiplierPos.symbolId);
            this._symbolMultiplierArr.push(multiplier);
            this._staticFeatureContainer.addChild(multiplier);
            multiplier.scale.set(0);
            tl.add(TweenLite.to(multiplier.scale, 0.8, {
                x: 0.8, y: 0.8, onComplete: () => {
                    TweenLite.to(multiplier.scale, 0.1, {
                        x: 1.3, y: 1.3, onComplete: () => {
                            TweenLite.to(multiplier.scale, 0.2, {x: 1, y: 1});
                        }
                    })
                }
            }), 0);
            tl.add(TweenLite.fromTo(multiplier, 0.5, {x: pos[0], y: pos[1]}, {
                x: multiplier.targetPos.x, y: multiplier.targetPos.y
            }), 0);
        });
        tl.add(() => SoundManager.playSound(RomanEmpireSoundConfig.instance.RFB_MULTI_HIGHLIGHT), 0.8);
        multiplierOverlay.length && tl.add(TweenLite.to({}, 1, {}));
        return tl;
    }

    /**
     * To create and transform symbol into wild.
     * @param position
     */
    private getWildTransformTimeline(position: ISymbolPositions): Timeline {
        const sprite: TimelineSprite = this.createSprite("randomWild", position, 25, this._staticFeatureContainer);//new TimelineSprite(textures);
        sprite.hide();
        //sprite.y -= 2;//wild is bit down in m2 m3 frame
        this._wildSymArr.push({
            sprite: sprite,
            reelId: position.reelId,
            symbolId: position.symbolId
        });
        return sprite.getAnimationAutoShowHide(true, false);
    }

    public stopPresentation(isAborted: boolean): void {
        this._dynamicFeatureContainer.removeChildren();
    }


    /**
     * To play Genie Scatter presentation
     * @param extraScatter
     */
    public startGenieFSPresentation(triggeredSymArr: ISymbolPositions[]): TimelineLite {
        const timeline: TimelineLite = new TimelineLite();
        timeline.add([this.getRevealScatterSprite(triggeredSymArr), this.getRevealSymbolsTimeline(triggeredSymArr, this.SCATTER_NAME),
            () => SoundManager.playFSScatterFire()]);
        return timeline;
    }

    /**
     * To replace symbol for reveal animation
     * @param scatterPos : position of reveal symbols
     * @param replaceSymbolName : name of symbol need to be replaced
     */
    private getRevealSymbolsTimeline(scatterPos: ISymbolPositions[], replaceSymbolName: string) {
        const tl: TimelineLite = new TimelineLite();

        scatterPos.forEach((scatterSym, index) => {
            let symbol: StateReelSymbol | null = Reels.getSymbol(scatterSym.reelId, scatterSym.symbolId);
            if (symbol) {
                tl.add(() => {
                    symbol!.replaceWith(replaceSymbolName, symbol!.reelId);
                })
            }
        });
        return tl;
    }

    /**
     * To get reveal puffs animation
     * @param scatterPos : position of reveal symbols
     */
    private getRevealScatterSprite(scatterPos: ISymbolPositions[]): Timeline[] {
        const scatterRevealSpriteAr: Timeline[] = [];
        scatterPos.forEach((scatterSym, index) => {
            const sprite = this.createSprite("puffs", {
                reelId: scatterSym.reelId,
                symbolId: scatterSym.symbolId
            });
            const spriteCopy = this.createSprite("puffs", {
                reelId: scatterSym.reelId,
                symbolId: scatterSym.symbolId
            });
            spriteCopy.alpha = 0.8;
            sprite.y -= 30;
            spriteCopy.y -= 30;
            sprite.tint = 0x1BEEFA;
            spriteCopy.tint = 0x1BEEFA;
            sprite.blendMode = PIXI.BLEND_MODES.ADD;
            spriteCopy.blendMode = PIXI.BLEND_MODES.ADD;
            sprite.hide();
            spriteCopy.hide();
            scatterRevealSpriteAr.push(sprite.getAnimationAutoShowHide(true, false));
            scatterRevealSpriteAr.push(spriteCopy.getAnimationAutoShowHide(true, false));
        });
        return scatterRevealSpriteAr;
    }

    /**
     * To play Genie Wild presentation
     * @param wilds
     */
    public startGenieWildPresentation(triggeredPos: ISymbolPositions[], wilds: ISymbolPositions[]): TimelineLite {
        const timeline: TimelineLite = new TimelineLite();
        this._wildSymArr.length = 0;
        wilds.forEach((wildPos: ISymbolPositions) => {
            timeline.add(this.getWildTransformTimeline(wildPos), 0);
        });

        return timeline;
    }

    private createSprite(texture: string, position?: ISymbolPositions | number[], sourceFPS?: number, parent?: PIXI.Container, isJPEG: boolean = false): TimelineSprite {
        const textures: PIXI.Texture [] = GameResources.getTextures(texture);
        const sprite: TimelineSprite = new TimelineSprite(textures, sourceFPS);
        sprite.anchor.set(0.5, 0.5);
        if (position) {
            position = position instanceof Array ? position : Helper.getSymbolPositions(position.reelId, position.symbolId);
            sprite.position.set(position[0], position[1]);
        }
        isJPEG && (sprite.blendMode = PIXI.BLEND_MODES.ADD);
        parent ? parent.addChild(sprite) : this._dynamicFeatureContainer.addChild(sprite);
        return sprite;
    }

    /**
     * To remove all feature text highlights
     */
    private removeHighlight(): void {
    }

    public reset() {
        this.addMultiplierOnReelSym();
        this.removeHighlight();
        this._dynamicFeatureContainer.removeChildren();
        //this._beforeSymLayer.removeChildren();
        this._staticFeatureContainer.removeChildren();
    }

    public resetLayer() {
        this._layer.position.set(0, 0); //to fix #277 prod bug
    }

    private addMultiplierOnReelSym() {
        this._symbolMultiplierArr.forEach((multiplier: Multiplier) => {
            const sym: StateReelSymbol | null = Reels.getSymbol(multiplier.reelId, multiplier.symbolId);
            if (sym) {
                sym.addChild(multiplier);
                multiplier.position.set(GameConfig.instance.SYMBOL_WIDTH * 0.5 - multiplier.width * 0.5, GameConfig.instance.SYMBOL_HEIGHT * 0.5 - multiplier.height * 0.6);
            }
        });
        this._symbolMultiplierArr.length = 0;
    }


    /**
     * To create lock timeline sprite.
     * @param position
     */
    public getLockAnim(position: ISymbolPositions): Timeline {
        let pos = Helper.getSymbolPositions(position.reelId, position.symbolId);
        pos[0] += RomanEmpireGameConfig.instance.SYMBOL_WIDTH * 0.5;
        const sprite: TimelineSprite = this.createSprite("lock", pos, 40, this._dynamicFeatureContainer);//new TimelineSprite(textures);
        sprite.hide();
        return sprite.getAnimationAutoShowHide(true, true);
    }

    public dimSymbol(symArr: ISymbolPositions[], isDim: boolean = true) {
        symArr.forEach((symPos) => {
            const sym = Reels.getSymbol(symPos.reelId, symPos.symbolId);
            sym?.changeState({
                state: isDim ? RomanEmpireGameConfig.instance.SYMBOL_STATES.noWin : RomanEmpireGameConfig.instance.SYMBOL_STATES.normal
            })
        });
    }

    private getMultiplierPos(total: number, radius: number): PIXI.Point[] {
        const posArr: PIXI.Point[] = [];
        const angleInRad: number = (360 / total) * (Math.PI / 180);
        for (let i = 1; i < total + 1; i++) {
            const point = new PIXI.Point(Math.round(radius * Math.cos(angleInRad * i)), Math.round(radius * Math.sin(angleInRad * i)));
            posArr.push(point);
        }
        return posArr.reverse();
    }
}